// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pineco: PokeData = {
  "id": 204,
  "name": "pineco",
  "height": 6,
  "weight": 72,
  "base_experience": 58,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "bide",
    "self-destruct",
    "explosion",
    "curse",
    "protect",
    "spikes",
    "rollout",
    "rapid-spin",
    "iron-defense",
    "gyro-ball",
    "natural-gift",
    "payback",
    "bug-bite",
    "autotomize"
  ],
  "moves": [
    "tackle",
    "curse",
    "protect",
    "bug-bite",
    "pin-rush",
    "sticky-web",
    "string-shot",
    "heal-order",
    "infest",
    "pin-missile",
    "leech-steal",
    "bug-buzz",
    "lunge"
  ],
  "evolution_chain": {
    "id": 102,
    "item": null,
    "species": [
      {
        "name": "pineco",
        "order": 235,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "forretress",
        "order": 236,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 204,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.25,
    "speed": 15,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
